import Header from 'components/headers/bulletins'
import DotsLoading from 'components/loadings/dotsLoading'
import { useCallback, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import useGetAdminSettlements from './hooks/useGetAdminSettlements'
import Item from './item'
import SettlementConfirmModal from 'components/modals/settlementConfirm'
import IsChashinStatusModal from 'components/modals/isCashinStatus'
export default function AdminSettlement() {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [isOpenCashinModal, setIsOpenCashinModal] = useState<boolean>(false)
    const [cashinAmount, setCashinAmount] = useState<number>(0)
    const [selectedItem, setSelectedItem] = useState<
        IAdminSettlementResult | undefined
    >()
    const { settlements, isLoadingSettlements, fetchNextPage, refetch } =
        useGetAdminSettlements()
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])
    return (
        <>
            <div className=" relative min-h-screen">
                <Header title="درخواست تسویه و خروج" />
                {isLoadingSettlements ? (
                    <DotsLoading />
                ) : (
                    <InfiniteScroll
                        next={onWatchEnd}
                        hasMore={
                            settlements
                                ? settlements?.pages[
                                      settlements.pages.length - 1
                                  ].next
                                    ? true
                                    : false
                                : false
                        }
                        dataLength={
                            settlements
                                ? settlements.pages.flatMap((x) => x.results)
                                      .length
                                : 0
                        }
                        loader={<DotsLoading />}
                    >
                        <div>
                            {settlements &&
                                settlements.pages
                                    .flatMap((x) => x.results)
                                    .map((item) => (
                                        <Item
                                            item={item}
                                            refetch={refetch}
                                            key={item.id}
                                            setIsOpenModal={setIsOpen}
                                            setSelectedItem={setSelectedItem}
                                        />
                                    ))}
                        </div>
                    </InfiniteScroll>
                )}
            </div>
            <SettlementConfirmModal
                show={isOpen}
                onHide={() => setIsOpen(false)}
                name={
                    selectedItem
                        ? `${selectedItem.requesting_user.member.first_name} ${selectedItem.requesting_user.member.last_name}`
                        : ''
                }
                poolShip={selectedItem && selectedItem.requesting_user.id}
                setIsOpenCashinModal={setIsOpenCashinModal}
                setCashinAmount={setCashinAmount}
            />
            <IsChashinStatusModal
                show={isOpenCashinModal}
                onHide={() => setIsOpenCashinModal(false)}
                name={
                    selectedItem
                        ? `${selectedItem.requesting_user.member.first_name} ${selectedItem.requesting_user.member.last_name}`
                        : ''
                }
                price={cashinAmount}
            />
        </>
    )
}
